import { render, staticRenderFns } from "./EInvoiceTaxBreakdownTable.vue?vue&type=template&id=fa066c5a&scoped=true"
import script from "./EInvoiceTaxBreakdownTable.vue?vue&type=script&lang=js"
export * from "./EInvoiceTaxBreakdownTable.vue?vue&type=script&lang=js"
import style0 from "./EInvoiceTaxBreakdownTable.vue?vue&type=style&index=0&id=fa066c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa066c5a",
  null
  
)

export default component.exports